"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayIES = displayIES;
exports.handleJobClick = handleJobClick;
const __1 = require("..");
const filter_1 = require("./filter");
const auto_1 = __importDefault(require("chart.js/auto"));
// @ts-nocheck
function displayIES(resultsList) {
    var header = '';
    document.title = 'Calculatrices - Etat de Neuchâtel';
    // test if not iframe
    if (self == top)
        header = `
            <span class="title">${__1.TITLE}</span>
            <span class="description secondaryColor">${__1.DESCRIPTION2}</span>
        `;
    let app = document.getElementById('app');
    app.innerHTML = `
        <style>
            :root {
                --fontColor: ${__1.FONT_COLOR};
                --linkColor: ${__1.LINK_COLOR};
            }
        </style>
        <div class="container">
            <div class="IEScalculator">
                        <div class="row">
                            ${header}

                            <div class="col ">
                                <div id="intro">${__1.INTRO2}</div>
                                <div id="jobs"></div>
                            </div>
                        </div>

            </div>
        </div>
    `;
    const jobs = document.createElement('div');
    jobs.innerHTML = `
            
                <div class="container">
                    <div class="row">
                        <div class="column">
                            <div class="header">

                                <div style="margin-bottom: 15px;">
                                    ${__1.SUBSCRIBE_LINK ? '<a class="subscribe link" href="' + __1.SUBSCRIBE_LINK + '" target="_blank">' : ''}
                                    ${__1.SUBSCRIBE_TEXT}
                                    ${__1.SUBSCRIBE_LINK ? '</a>' : ''}
                                    ${__1.SRHE_LINK ? '<a class="srhe link" href="' + __1.SRHE_LINK + '" target="_blank">' : ''}
                                    ${__1.SRHE_TEXT}
                                    ${__1.SRHE_LINK ? '</a><br/>' : ''}

                                </div>
                                <hr>
                                <div style="font-size: 25px">
                                 <b>Statut financier</b> :
                                 		<select name="status" id="status">
										  <option value="REVENU">Revenu</option>
										  <option value="RENTE AVS">Rente AVS</option>
										  <option value="RENTE AI">Rente AI</option>
										</select>
										<br>
                                 <b>Nombre de personnes de la famille</b> :
                                      <select name="nb" id="nb">
										  <option value="1">1</option>
										  <option value="2">2</option>
										  <option value="3">3</option>
										  <option value="4">4</option>
										  <option value="5">5</option>
										  <option value="6">6</option>
										</select>
										<br>
                                 <b>Total Revenu</b> :<input id="revenu"  type="number" class="form-text" style="background-color: var(--color-neutral-100);" placeholder="CHF">
                            	
                            	<button id="submit" type="submit" aria-hidden="true" style="padding: 10px !important;" class="nech-button__ratio  nech-button inline-flex items-center ease-default transition-all duration-300  text-neutral-50 relative bg-primary-700 hover:bg-primary-800 active:text-primary-600 active:bg-primary-800 rounded-400  cta-m  py-4  px-5  flex justify-center rounded-400 max-h-9  w-9 " tabindex="0">
								Calculer
								</button>
                            	</div>
                            </div>
                            <div id="count-jobs"></div>
                            <br>

                            <div id="job-list">
                          
                            </div>
                        </div>
                    </div>
                </div>

        `;
    const jobsElement = document.querySelector('#jobs');
    if (jobsElement) {
        jobsElement.appendChild(jobs);
    }
    else {
        console.error("Element with id 'jobs' not found.");
    }
    if (__1.Resultslist.length)
        renderFilteredJobs(__1.Resultslist);
}
function renderFilteredJobs(filteredJobs) {
    // Préparer labels et data
    const labels = __1.Resultslist.map(item => item.taux_prestation);
    const dataValues = __1.Resultslist.map(item => item.prix_parent);
    // Créer le canvas dynamiquement (ou dans index.html)
    let canvas = document.createElement("canvas");
    canvas.id = "taux-prix";
    document.body.appendChild(canvas);
    const data = {
        labels: labels,
        datasets: [{
                label: 'Prix',
                data: __1.Resultslist.map(item => item.prix_parent),
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)'
            }, {
                type: 'line',
                label: 'Contrib',
                data: __1.Resultslist.map(item => item.participation_communale),
                fill: false,
                borderColor: 'rgb(54, 162, 235)'
            }]
    };
    // Créer le graphique
    //const ctx = document.getElementById('taux-prix') as HTMLCanvasElement | null;
    const ctx = false;
    if (ctx) {
        new auto_1.default(canvas, {
            type: 'bar',
            data: {
                datasets: [{
                        label: 'Prix',
                        data: __1.Resultslist.map(item => item.prix_parent),
                        borderColor: 'rgb(255, 99, 132)',
                        backgroundColor: 'rgba(255, 99, 132, 0.2)'
                    }, {
                        type: 'line',
                        label: 'Contrib',
                        data: __1.Resultslist.map(item => item.participation_communale),
                        fill: false,
                        borderColor: 'rgb(54, 162, 235)'
                    }],
                labels: labels
            },
            options: {
                responsive: true,
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            }
        });
    }
    var revenu = document.getElementById('revenu').value;
    const vals = filteredJobs.at(0).values;
    var prix = vals[3];
    if (prix[0] == '-')
        prix = ' 0 CHF';
    var printJobs = `
    <div class="results" style="font-size: 23px;">
		Statut financier : <b>${vals.at(0)}</b> <br>
		Nombre de personnes de la même famille dans le ménage : <b>${vals[1]}</b><br>
		Total des revenus de l'activité, rentes et pensions (ch. 2.6 de la taxation fiscale) : <b>${new Intl.NumberFormat("fr-CH").format(vals[2])} CHF</b>  <br>
		Contribution journalière à charge des parents : <b>${prix}</b><br>	
	</div>
	`;
    var printCardJobs = ` <div class="container">
    <div class="row">
        `;
    let first = true;
    const jobListElement = document.getElementById('job-list');
    if (jobListElement) {
        jobListElement.innerHTML = printJobs;
    }
    /* const count = document.getElementById('count-jobs');
     if (count)
         count.innerHTML = '<h2><span class="nb">' + filteredJobs.length + '</span> Prestations par taux <span id="filtered">filtrées</span></h2><br>';
     */
}
function resetFilters() {
    document.querySelectorAll('.checkbox-container input:checked').forEach((checkbox) => {
        checkbox.checked = false;
    });
    applyFilters();
    (0, filter_1.updateAccordionVisibility)();
    const textFiltered = document.getElementById('filtered');
    const clearFiltersButton = document.getElementById('clear-filters');
    if (textFiltered && clearFiltersButton) {
        textFiltered.style.display = 'none';
        clearFiltersButton.style.display = 'none';
    }
}
function applyFilters() {
    const selectedDomains = Array.from(document.querySelectorAll('.checkbox-container.taux- input:checked')).map(e => Number(e.name));
    // Save filter state to localStorage
    localStorage.setItem('selectedDomains', JSON.stringify(selectedDomains)); // Added line
    const filteredJobs = __1.Resultslist.filter(job => {
        return (selectedDomains.length === 0 || selectedDomains.includes(parseInt(job.taux_prestation)));
    });
    renderFilteredJobs(filteredJobs);
    handleJobClick();
    const clearFiltersButton = document.getElementById('clear-filters');
    const textFiltered = document.getElementById('filtered');
    if (textFiltered && clearFiltersButton && (selectedDomains.length)) {
        clearFiltersButton.style.display = 'block';
        textFiltered.style.display = 'inline-block';
    }
}
function handleJobClick() {
    let elems = document.querySelectorAll('.card-link ');
    Array.from(elems).forEach((element) => {
        element.addEventListener("click", function (e) {
            e.preventDefault();
            let link = e.currentTarget;
            if (link.pathname) {
                window.history.pushState('', "Détail", link.pathname);
                var popStateEvent = new PopStateEvent('popstate');
                dispatchEvent(popStateEvent);
            }
        });
    });
}
